/**
 * @file Web Gallery Blog Post.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import moment from 'moment';

import { getThumbBySize } from '../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../constants/image-size-codes';
import Spinner from '../../../components/global/Spinner';
import ContentWrap from '../../../components/global/ContentWrap';
import WebGalleryBlogPostLink from './WebGalleryBlogPostLink';
import WebGalleryBlogToolbar from './WebGalleryBlogToolbar';
import { getWebGalleryBlogPath } from '../utilities/web-galleries';

const propTypes = {
  entity: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  blogPost: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    excerpt: PropTypes.string,
    custom_exceprt: PropTypes.string,
    content: PropTypes.string,
    cover_photo: PropTypes.shape({
      id: PropTypes.string,
      thumbnail_urls: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
        }),
      ),
    }),
  }),
  loading: PropTypes.bool,
};

const WebGalleryBlogPost = ({ entity, blogPost, loading }) => {
  if (loading || !blogPost) {
    return (
      <div className="d-flex mt-4">
        <Spinner className="m-auto" />
      </div>
    );
  }

  const coverPhotoThumbnail = getThumbBySize(
    get(blogPost, 'cover_photo.thumbnail_urls'),
    IMAGE_SIZE_CODE.LARGE,
  );

  const [blogPostLink] = get(blogPost, 'blog_post_links.records', []);

  return (
    <Fragment>
      <WebGalleryBlogToolbar
        entity={entity}
        backUrl={getWebGalleryBlogPath(entity)}
      />
      <div
        data-testid="web-gallery-blog-post"
        className="content-wrap-gray flex-auto"
      >
        <ContentWrap size="lg" mainClassName="p-0">
          {coverPhotoThumbnail && (
            <div className="container-fluid p-0">
              <div className="web-gallery-blog-post-header">
                <figure className="web-gallery-blog-post-header-image">
                  <img src={coverPhotoThumbnail.url} alt="cover" />
                </figure>
              </div>
            </div>
          )}
          <div className="p-5">
            <div className="mb-3">
              <h3 className="mb-0">{blogPost.title}</h3>
              <time className="web-gallery-blog-post-card-time">
                {moment(blogPost.created_at).format('DD MMM, YYYY')}
              </time>
            </div>
            {blogPostLink && (
              <WebGalleryBlogPostLink
                blogPostLink={blogPostLink}
                className="my-3 d-block"
              />
            )}
            <div className="web-gallery-blog-post-content">
              <div
                /* eslint-disable-next-line react/no-danger */
                dangerouslySetInnerHTML={{ __html: blogPost.content }}
              />
            </div>
          </div>
        </ContentWrap>
      </div>
    </Fragment>
  );
};

WebGalleryBlogPost.propTypes = propTypes;

export default WebGalleryBlogPost;
